/** What a `ticket.*` event carries: the saved ticket, or a bare id when it was deleted. */
export type TicketEventPayload =
	| { id?: number; client?: { id: number } | null; contact?: { id: number } | null }
	| null
	| undefined;

/** The events that can add a ticket to, or take one from, a card's counts. */
export const TICKET_EVENTS = ['ticket.added', 'ticket.updated', 'ticket.deleted'];

type Scope = { clientIds: (number | string)[] } | { contactId: number | string };

/**
 * Whether a `ticket.*` event can change what a card counts for its companies or contact.
 * Every ticket write in the account is pushed to every open browser, so a card that refetches
 * on all of them re-counts once per ticket anyone touches (WEB-14259). A delete arrives as a
 * bare id and could be anyone's, so it always counts.
 */
export function ticketEventConcerns(ticket: TicketEventPayload, scope: Scope): boolean {
	if (!ticket || !('client' in ticket)) {
		return true;
	}
	if ('contactId' in scope) {
		return !!ticket.contact && ticket.contact.id === Number(scope.contactId);
	}
	return !!ticket.client && scope.clientIds.map(Number).includes(ticket.client.id);
}
